import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import translations from './translations.en.json';
import GigBanner from './GigBanner/GigBanner';
import VacationPopup from './VacationPopup/VacationPopup';
import {reportEvent, turnVacationOff} from './helper';
import ProfileBanner from './ProfileBanner/ProfileBanner';
import '@fiverr/globals';
import './index.scss';

class OutOfOffice extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);

        this.state = {
            isOpen: false,
            dateVal: 0,
            buyerMessage: props.message_for_buyer,
            allowContact: props.allow_contact,
            whyVacation: props.reason,
            isOnVacation: props.is_on_vacation,
            isPageOwner: props.is_page_owner
        };

        this.openPopup = this.openPopup.bind(this);
        this.submitAllVacationDetails = this.submitAllVacationDetails.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.turnOff = this.turnOff.bind(this);
        this.updateDate = this.updateDate.bind(this);
    }

    componentDidMount() {
        this.updateDate();

        document.addEventListener('open_popup', (e) => {
            if (e.detail) {
                this.openPopup(e);
                return;
            }
            
            this.setState({isOnVacation: e.detail});

            reportEvent('click_off', {
                'current_page_type': 'seller_page',
                'seller': {
                    'id': this.props.user_id
                }
            });
        });
    }

    componentWillUnmount() {
        document.removeEventListener('open_popup', this.openPopup);
    }

    updateDate() {
        this.setState({dateVal:this.props.end_date});
    }

    submitAllVacationDetails(data) {
        this.setState({
            dateVal: data.endDate,
            buyerMessage: data.buyerMessage,
            allowContact: data.allowContact,
            whyVacation: data.whyVacation,
            isOnVacation: true,
            isPageOwner: true
        });
    }

    openPopup(e, type = null) {
        e && e.preventDefault();

        // BI event
        type ? reportEvent('click_edit', {current_page_type: type}) : reportEvent('click_on');

        this.setState({
            isOpen: true
        });
    }

    closePopup(e, data, fromSubmit = false) {
        // closed without submit
        if (!fromSubmit) {

            // in case of ooo off close the toggle.
            if (!this.state.isOnVacation) {
                const event = new CustomEvent('popup_close', {detail: false});
                document.dispatchEvent(event);
            }
        } else if (e && e.preventDefault) {
            e.preventDefault();
        }

        data && this.submitAllVacationDetails(data);

        this.setState({
            isOpen: false
        });
    }

    turnOff() {
        turnVacationOff(this.props.username)
            .then(() => {
                this.setState({
                    isOnVacation: false
                }, () => this.closePopup(null, null, false));
            });
    }

    render() {
        const {
            profile_image_url,
            type,
            user_id,
            gig_id,
            username,
            isMobileResponsive
        } = this.props;

        const Banner = type === 'profile' ? ProfileBanner : GigBanner,
            isMobilePS = !!Fiverr.models && !!Fiverr.models.ps ? !!Fiverr.models.ps.isMobileResponsive : false,
            isMobile = typeof isMobileResponsive !== 'undefined' ? isMobileResponsive : isMobilePS;

        return (
            <div className="out-of-office">
                <Banner {...this.state}
                    profileImageUrl={profile_image_url}
                    userId={user_id}
                    gigId={gig_id}
                    username={username}
                    openPopup={this.openPopup}
                    turnOff={this.turnOff}
                    isMobile={isMobile}/>
                {this.state.isOpen &&
                    <VacationPopup {...this.state}
                        userId={user_id}
                        closePopup={this.closePopup}/>}
            </div>
        );
    }
}

OutOfOffice.propTypes = {
    type: PropTypes.string.isRequired,
    is_page_owner: PropTypes.bool,
    user_id: PropTypes.number.isRequired,
    gig_id: PropTypes.number,
    end_date: PropTypes.number,
    reason:PropTypes.string,
    allow_contact:PropTypes.bool,
    message_for_buyer: PropTypes.string
};

OutOfOffice.defaultProps = {
    type: 'profile',
    user_id: 0,
    gig_id: 0,
    is_on_vacation: false,
    is_page_owner: false,
    isOpen: false,
    allow_contact: false
};

export default OutOfOffice;


// WEBPACK FOOTER //
// ./src/OutOfOffice.js